module.exports = __webpack_public_path__ + "img/pr-1.e5f16260.png";